import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { RenaultManagerUserDTO } from '../models/renault-manager-user-dto';

@Injectable({
  providedIn: 'root'
})

export class RenaultManagerUserService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultManagerUser/";

  public userData = new BehaviorSubject<RenaultManagerUserDTO | null>(null);
  
  constructor(private http: HttpClient) { }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });    
  }

  public getUserInfo(): Observable<RenaultManagerUserDTO> {    
    return this.http.get<RenaultManagerUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  public updateLastLoginDate(): Observable<any> {    
    return this.http.get<any>(this.pathAPI + this.controller + 'UpdateLastLoginDate');
  }
  
  setUserData(user: RenaultManagerUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<RenaultManagerUserDTO | null> {
    if (this.userData.value != null) {
      return of(this.userData.value);
    }
    else {
      return this.getUserInfo().pipe(map((userData: RenaultManagerUserDTO) => {
        this.setUserData(userData);
        return userData;
      }),
        catchError((err) => {
          return of(null);
        }));
    }
  }


}